import { DirectionsBoat, Person } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { InvoiceFormField } from "./InvoiceFormField";

export const InvoiceClient = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Person style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Client")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div style={{ display: "flex", flexWrap: "wrap" }}>
                <InvoiceFormField label={t("ClientCode")} type="disabled" code="ClientCode" data={dataState} setData={setDataState} />
                <InvoiceFormField label={t("ClientName")} type="disabled" code="ClientName" data={dataState} setData={setDataState} />
            </div>
            
            <div>
                <InvoiceFormField label={t("Client")} type="disabled" code="ClientLine1" size={"100%"} data={dataState} setData={setDataState} />
                <InvoiceFormField hideLabels={true} type="disabled" code="ClientLine2" size={"100%"} data={dataState} setData={setDataState} />
                <InvoiceFormField hideLabels={true} type="disabled" code="ClientLine3" size={"100%"} data={dataState} setData={setDataState} />
                <InvoiceFormField hideLabels={true} type="disabled" code="ClientLine4" size={"100%"} data={dataState} setData={setDataState} />
                <InvoiceFormField hideLabels={true} type="disabled" code="ClientLine5" size={"100%"} data={dataState} setData={setDataState} />
                <InvoiceFormField hideLabels={true} type="disabled" code="ClientLine6" size={"100%"} data={dataState} setData={setDataState} />
            </div>
          </div>
        }
      />
    </>
  )
}